<template>
    <p id="name" :style="`color: ${theme.projectTitle}`">{{ name }}</p>
</template>

<script>
export default {
    name: "ProjectName",
    props: {
        name: String,
        theme: Object
    }
};
</script>